import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CookieService } from "ngx-cookie-service";
import { UserService } from "../data/user.service";
import { UserIdleService } from "angular-user-idle";

@Injectable({ providedIn: "root" })
export class AuthService {
  cookieDomain: string;
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private userService: UserService,
    private userIdle: UserIdleService
  ) {
    this.cookieDomain = environment.cookieDomain;
  }

  checkAuth() {
    if (environment.maintenanceMode) {
      return false;
    } else {
      let lwca_Auth = this.cookieService.get("LWCA_AUTH");
      let lwca_User = this.cookieService.get("LWCA_USER");
      if (
        sessionStorage.userInfo &&
        JSON.parse(sessionStorage.userInfo) &&
        lwca_Auth &&
        lwca_Auth !== "" &&
        lwca_User &&
        lwca_User !== ""
      ) {
        // logged in so return true
        return true;
      }

      // not logged in so redirect to login page with the return url
      this.router.navigate(["/login"]);
      return false;
    }
  }

  async logout() {
    await this.userService.logout().toPromise();
    sessionStorage.removeItem("userInfo");
    const expire = new Date(1970, 1, 1, 0, 0, 0, 0);
    this.cookieService.set("LWCA_AUTH", null, expire);
    this.cookieService.set("LWCA_USER", null, expire);
    this.cookieService.delete("LWCA_AUTH", "/", this.cookieDomain);
    this.cookieService.delete("LWCA_USER", "/", this.cookieDomain);
    this.userIdle.stopWatching();
    this.userIdle.stopTimer();
    sessionStorage.setItem("redirectToSSOLogout", JSON.stringify(true));
    this.router.navigate(["/login"]);
  }
}
